exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#calendar .fc-bgevent {\r\n    background: #c52e2e;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/main/calendarioAnual/calendarioAnual.component.css
// module id = ../../../../../src/app/main/calendarioAnual/calendarioAnual.component.css
// module chunks = main